import React from 'react';
import { PageHero, Card } from '../components/ui';

export default function CompensationDisclosure() {
    return (
        <div className="bg-slate-50 dark:bg-slate-900 min-h-screen transition-colors duration-200">
            <PageHero
                title="Compensation Disclosure"
                subtitle="Transparency is important to us. Here's how we make money."
            />

            <main className="container mx-auto px-4 -mt-16 relative z-10 pb-16 max-w-4xl">
                <Card>
                    <div className="text-base text-slate-700 dark:text-slate-300 leading-relaxed space-y-8">
                        <p>
                            Gift Scout LLC helps you save money and manage your gift cards. To support our operations, we participate in affiliate marketing programs.
                        </p>

                        <h2 className="text-2xl font-bold text-slate-800 dark:text-white pt-4 border-b border-slate-200 dark:border-slate-700 pb-2">What Are Affiliate Links?</h2>
                        <p>
                            Some of the links to gift card deals on our site are affiliate links. This means we may earn a commission when you make a purchase through one of these links.
                        </p>
                        <p>
                            This commission comes at <strong className="font-semibold text-slate-800 dark:text-white">no extra cost to you</strong>. The price you pay is the same whether you use our link or go directly to the vendor.
                        </p>

                        <h2 className="text-2xl font-bold text-slate-800 dark:text-white pt-4 border-b border-slate-200 dark:border-slate-700 pb-2">FTC Compliance</h2>
                        <p>
                            In accordance with the Federal Trade Commission's guidelines, we disclose our affiliate relationships. Any compensation received does not influence our editorial decisions or the visibility of specific deals.
                        </p>

                        <h2 className="text-2xl font-bold text-slate-800 dark:text-white pt-4 border-b border-slate-200 dark:border-slate-700 pb-2">Our Commitment</h2>
                        <p>
                            We strive to surface the best deals, regardless of affiliate relationships. Your trust is important to us, and we prioritize value and transparency in our recommendations.
                        </p>

                        <p className="text-sm text-slate-500 pt-6">
                            Have questions? Please <a href="/contact" className="text-brand-600 dark:text-brand-400 hover:underline font-medium">contact us</a>.
                        </p>
                    </div>
                </Card>
            </main>
        </div>
    );
}
